import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import api from "../utils/api";
import { Bell, Save, ArrowLeft, Mail } from "lucide-react";

export default function NotificationPrefsPage() {
  const [events, setEvents] = useState({});
  const [prefs, setPrefs] = useState({});
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/auth/notification-prefs").then(r => {
      setEvents(r.data.events || {});
      setPrefs(r.data.prefs || {});
    });
  }, []);

  const toggle = (k) => setPrefs({ ...prefs, [k]: !prefs[k] });

  const save = async () => {
    setSaving(true); setMsg("");
    try {
      const r = await api.put("/auth/notification-prefs", { prefs });
      setPrefs(r.data.prefs);
      setMsg("Preferences saved.");
    } catch (e) {
      setMsg(e.response?.data?.detail || "Failed");
    } finally { setSaving(false); }
  };

  const sendTest = async () => {
    setTesting(true); setMsg("");
    try {
      await api.post("/auth/notifications/test-email");
      setMsg("Test email sent — check your inbox.");
    } catch (e) {
      setMsg(e.response?.data?.detail || "Failed");
    } finally { setTesting(false); }
  };

  return (
    <Layout>
      <div className="animate-in" style={{ maxWidth: "760px", margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1.25rem" }}>
          <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)" }}><ArrowLeft size={18} /></button>
          <h1 style={{ fontFamily: "Bricolage Grotesque, sans-serif", fontWeight: 600, fontSize: "1.5rem", margin: 0, display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Bell size={18} style={{ color: "#8B5CF6" }} /> Notification preferences
          </h1>
        </div>

        <div className="recon-card" style={{ padding: "1.25rem", marginBottom: "1rem" }}>
          <p style={{ color: "var(--text-muted)", fontSize: "0.85rem", margin: "0 0 1rem" }}>
            Turn on or off the events you'd like emailed to you. Delivery uses the app's SMTP settings (configured by the superadmin).
          </p>
          <div data-testid="notif-events-list" style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            {Object.entries(events).map(([k, label]) => (
              <label key={k} data-testid={`notif-event-${k}`} style={{ display: "flex", alignItems: "center", gap: "0.6rem", padding: "0.5rem 0.75rem", background: "#f9fafb", borderRadius: "0.4rem", cursor: "pointer", fontSize: "0.88rem" }}>
                <input type="checkbox" checked={!!prefs[k]} onChange={() => toggle(k)} data-testid={`notif-check-${k}`} />
                <span style={{ flex: 1 }}>{label}</span>
                <code style={{ fontSize: "0.7rem", color: "var(--text-muted)", background: "#eef2ff", padding: "0.1rem 0.4rem", borderRadius: "0.25rem" }}>{k}</code>
              </label>
            ))}
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginTop: "1rem" }}>
            <button data-testid="notif-save" onClick={save} disabled={saving} className="btn-primary"
              style={{ fontSize: "0.9rem", display: "flex", alignItems: "center", gap: "0.3rem", opacity: saving ? 0.6 : 1 }}>
              <Save size={14} /> {saving ? "Saving…" : "Save"}
            </button>
            <button data-testid="notif-test-email" onClick={sendTest} disabled={testing} className="btn-secondary"
              style={{ fontSize: "0.9rem", display: "flex", alignItems: "center", gap: "0.3rem", opacity: testing ? 0.6 : 1 }}>
              <Mail size={14} /> {testing ? "Sending…" : "Send test email"}
            </button>
            {msg && <span data-testid="notif-msg" style={{ fontSize: "0.82rem", color: msg.startsWith("Fail") ? "#991b1b" : "#166534" }}>{msg}</span>}
          </div>
        </div>
      </div>
    </Layout>
  );
}
